function swapImages(){
    var $active = $('.map-images > .active');
    var $next = ($('.map-images > .active').next().length > 0) ? $('.map-images > .active').next() : $('.map-images > img:first');
    $active.fadeOut(function(){
        $active.removeClass('active');
        $next.fadeIn().addClass('active');
    });
}

function swapMap(){
    var $active = $('.map-details .active');
    var $next = ($('.map-details .active').next().length > 0) ? $('.map-details .active').next() : $('.map-details .map-item:first');
    $active.fadeOut("10",function(){
        $active.removeClass('active');
        $next.fadeIn().addClass('active');
    });
}

function swaptree(){
    var $active = $('.new-idea > .map-images > .tree-pointer.active');
    var $next = ($('.new-idea > .map-images > .tree-pointer.active').next().length > 0) ? $('.new-idea > .map-images > .tree-pointer.active').next() : $('.new-idea > .map-images > .tree-pointer:first');
    $active.removeClass('active');
    $next.addClass('active');
}


$(document).ready(function(e) {

    // $('img[usemap]').rwdImageMaps();

    // $("area.map1").hover(function(){
    //     $(".multiple-maps img").css('display','none');
    //     $(".multiple-maps img.map1").css('display','block');
    //     $(".map-details .map-item").css('display','none');
    //     $(".map-details .map-item-1").css('display','block');
    // });
    // $("area.map2").hover(function(){
    //     $(".multiple-maps img").css('display','none');
    //     $(".multiple-maps img.map2").css('display','block');
    //     $(".map-details .map-item").css('display','none');
    //     $(".map-details .map-item-2").css('display','block');
    // });

    // $("area.map3").hover(function(){
    //     $(".multiple-maps img").css('display','none');
    //     $(".multiple-maps img.map3").css('display','block');
    //     $(".map-details .map-item").css('display','none');
    //     $(".map-details .map-item-3").css('display','block');
    // });

    // $("area.map4").hover(function(){
    //     $(".multiple-maps img").css('display','none');
    //     $(".multiple-maps img.map4").css('display','block');
    //     $(".map-details .map-item").css('display','none');
    //     $(".map-details .map-item-4").css('display','block');
    // });
    // $("area.map5").hover(function(){
    //     $(".multiple-maps img").css('display','none');
    //     $(".multiple-maps img.map5").css('display','block');
    //     $(".map-details .map-item").css('display','none');
    //     $(".map-details .map-item-5").css('display','block');
    // });
    // $("area.map6").hover(function(){
    //     $(".multiple-maps img").css('display','none');
    //     $(".multiple-maps img.map6").css('display','block');
    //     $(".map-details .map-item").css('display','none');
    //     $(".map-details .map-item-6").css('display','block');
    // });

    // setInterval('swapImages()', 5000);
    // setInterval('swapMap()', 5000);
    
    

    $(".tree-pointer").hover(function(){
        $(".tree-pointer").removeClass('active');
        $(this).addClass('active');
       var attribute = $(this).attr('rel');
       $('.map-item').removeClass('active');
       ///console.log(attribute);
       $('.'+attribute).addClass('active');
    });
    

    $.fn.startSlider = function(){
        var sliderDIV=this;
        // var img=sliderDIV.find(".tree-pointer");
        var img=$(".tree-pointer");
        
        img.first().show().addClass("active");
        
        var pause = false;
        var iterateTickerElement = function() {
            setInterval(function(){
                if(!pause) {
                    var $active = $('.new-idea > .map-images > .tree-pointer.active, .map-details .map-item.active');
                    var $next = ($('.new-idea > .map-images > .tree-pointer.active, .map-details .map-item.active').next().length > 0) ? $('.new-idea > .map-images > .tree-pointer.active, .map-details .map-item.active').next() : $('.new-idea > .map-images > .tree-pointer:first, .map-details .map-item:first');
                    $active.removeClass('active');
                    $next.addClass('active');
                }
            },5000);
        }
        img.mouseover(
        function(){
            pause=true;
        },
        function(){
            pause=false;
        });
        iterateTickerElement();
    }


    $(".map-images, .map-details").startSlider();


     
    $('.partner-organizations').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000
    });
});



